import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { applyAuthResponse } from "../../lib/authSession";
import { applyAccountStatusToSession } from "../../lib/accountStatus";
import { getPostLoginPath } from "../../lib/authRoutes";
import { stopAdminImpersonation } from "../../admin/dashboard/adminApi";

/** Restore the original admin session after impersonation. */
export function useEndImpersonation() {
  const navigate = useNavigate();
  const [ending, setEnding] = useState(false);
  const [error, setError] = useState("");

  const endImpersonation = useCallback(async () => {
    setEnding(true);
    setError("");
    try {
      const data = await stopAdminImpersonation();
      applyAuthResponse(data);
      if (data?.user) {
        applyAccountStatusToSession(data.user);
      }
      navigate(getPostLoginPath(data?.user?.role || "admin"), { replace: true });
    } catch (err) {
      setError(
        err?.data?.detail ||
          err?.message ||
          "Admin-Sitzung konnte nicht wiederhergestellt werden."
      );
    } finally {
      setEnding(false);
    }
  }, [navigate]);

  return { endImpersonation, ending, error };
}

export default useEndImpersonation;
